/**
 * @description  Bot component status
 */

export default Object.freeze({
  READY: 'READY', // bot provider is ready
  REMOVED: 'REMOVED', // bot have been removed
  DOWN: 'DOWN', // bot sever(s) is(are) down
})
